export class AppMenuItem {
    name = '';
    permissions: string[] = [];
    icon = '';
    route = '';
    routeTemplates = [];
    items: AppMenuItem[];
    external: boolean;
    requiresAuthentication: boolean;
    featureDependency: any;
    img_on_hover: string;
    img_no_hover: string;
    parameters: {};


    constructor(
        name: string,
        permissions: string[],
        icon: string,
        route: string,
        routeTemplates?: string[],
        items?: AppMenuItem[],
        img_on_hover?: string,
        img_no_hover?: string,
        external?: boolean,
        parameters?: Object,
        featureDependency?: any,
        requiresAuthentication?: boolean

    ) {
        this.name = name;
        this.permissions = permissions;
        this.icon = icon;
        this.route = route;
        this.routeTemplates = routeTemplates;
        this.external = external;
        this.parameters = parameters;
        this.featureDependency = featureDependency;
        this.img_no_hover = img_no_hover;
        this.img_on_hover = img_on_hover;

        if (items === undefined) {
            this.items = [];
        } else {
            this.items = items;
        }

        if (this.permissions && this.permissions.length > 0) {
            this.requiresAuthentication = true;
        } else {
            this.requiresAuthentication = requiresAuthentication ? requiresAuthentication : false;
        }
    }

    hasFeatureDependency(): boolean {
        return this.featureDependency !== undefined;
    }

    featureDependencySatisfied(): boolean {
        if (this.featureDependency) {
            return this.featureDependency();
        }

        return false;
    }
}
